import { useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/constants/site";

const LINKS = [
  { href: "#stays", label: "Stays" },
  { href: "#gallery", label: "Gallery" },
  { href: "#reviews", label: "Reviews" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-[#FDFBF7]/95 backdrop-blur border-b border-[#E6E2D8] shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src={LOGO_URL} alt="Resort The Forest logo" className="h-12 w-12 object-contain" />
          <span className="font-serif-display text-xl tracking-wide text-[#0B3B39] hidden sm:block">
            Resort The Forest
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.2em] font-semibold text-[#4A5568] hover:text-[#0B3B39] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#reserve"
            data-testid="nav-book-now-btn"
            className="hidden md:inline-block bg-[#0B3B39] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] font-semibold px-7 py-3 rounded-sm hover:bg-[#072A28] transition-colors duration-300"
          >
            Book Now
          </a>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-[#0B3B39] p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#FDFBF7] border-t border-[#E6E2D8] px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.2em] font-semibold text-[#4A5568]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#reserve"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-book-now-btn"
            className="bg-[#0B3B39] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] font-semibold px-7 py-3 rounded-sm text-center"
          >
            Book Now
          </a>
        </div>
      )}
    </header>
  );
};
